import React from "react";
import dayjs from "dayjs";
import { Table } from "antd";
import { useSelector } from "react-redux";
import { useProjectState } from "../../../context/stateContext";
import MyMenuOrdersInfoModal from "./MyMenuOrdersInfoModal";

const MyMenuOrdersTable = () => {
  const { orders, loading } = useSelector((state) => state.myMenuOrdersReducer);

  const { setOpenMyMenuOrdersInfoModal } = useProjectState();

  const totalAmount = orders.reduce(
    (sum, order) => sum + Number(order.amount),
    0
  );
  const totalOrders = orders.length;

  const columns = [
    {
      title: "Дата на създаване",
      dataIndex: "createdDate",
      rowKey: "createdDate",
      width: "33%",
      sorter: (a, b) =>
        dayjs(a.createdDate).unix() - dayjs(b.createdDate).unix(),
      key: "createdDate",
      align: "center",
      render: (date) => (
        <span className="mymenu-orders-table-text">
          {dayjs(date).format("DD.MM - HH:mm")}
        </span>
      ),
    },
    {
      title: (
        <>
          Име на масата{" "}
          <span style={{ opacity: 0.6 }}>({totalOrders} бр.)</span>
        </>
      ),
      dataIndex: "tableName",
      rowKey: "tableName",
      width: "33%",
      sorter: (a, b) => a.tableName - b.tableName,
      align: "center",
      key: "tableName",
      render: (text) => (
        <span className="mymenu-orders-table-text">{text ? text : "-"}</span>
      ),
    },
    {
      title: (
        <>
          Сума <span style={{ opacity: 0.6 }}>({totalAmount.toFixed(2)})</span>
        </>
      ),
      dataIndex: "amount",
      rowKey: "amount",
      width: "33%",
      sorter: (a, b) => a.amount - b.amount,
      align: "center",
      key: "amount",
      render: (text) => (
        <span className="mymenu-orders-table-text">{text.toFixed(2)}</span>
      ),
    },
  ];

  return (
    <div className="mymenu-orders-table-container">
      <MyMenuOrdersInfoModal />
      <Table
        loading={loading}
        rowKey="orderID"
        showHeader
        dataSource={orders}
        columns={columns}
        pagination={false}
        onRow={(record) => {
          return {
            onClick: () => setOpenMyMenuOrdersInfoModal(record),
          };
        }}
        className="mymenu-orders-table"
      />
    </div>
  );
};

export default MyMenuOrdersTable;
